import {
  // ChevronUp,
  Edit,
  // Eye,
  // RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Brand from "../../core/modals/inventory/brand";
import { all_routes } from "../../Router/all_routes";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Table from "../../core/pagination/datatable";
// import { setToogleHeader } from "../../core/redux/action";
import { useSelector } from "react-redux";
// import { Download } from "react-feather";
import axios from "axios";
import MessageModal from "./MessageModal";

const ProductList = () => {
  // const dataSource = useSelector((state) => state.rootReducer.product_list);
  // const storeId = "67aa7f75-0ed9-4378-9b3d-50e1e34903ce";
  const storeId = useSelector((state) => state.user.storeId);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [messageModal, setMessageModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info",
  });
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);
  // const dispatch = useDispatch();
  const route = all_routes;
  // const data = useSelector((state) => state.rootReducer.toggle_header);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [showRestockColumns, setShowRestockColumns] = useState(false);
  const [showOnlyRestock, setShowOnlyRestock] = useState(false);
  // const [subcategories, setSubcategories] = useState([]);
  // const [selectedSubcategory, setSelectedSubcategory] = useState("");
  //  const apiBase = getConfig().API_BASE_URL;
  const apiBase =
    process.env.REACT_APP_BASEURL ||
    window.__APP_CONFIG__?.API_BASE_URL || "";


  // Fetch Api
  const getProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiBase}api/v1/Product/GetProducts?storeId=${storeId}`
      );
      const productList = response.data.data;
      const mappedData = productList.map((item) => {
        const stock = item.stock ? parseInt(item.stock) : 0;
        const quantityAlert = item.quantityAlert ? parseInt(item.quantityAlert) : 0;
        const restock = item.restock ?? false;
        // Only apply low stock logic if restock is true
        const isLowStock = restock ? stock <= quantityAlert : false;

        return {
          key: item.id,
          sku: item.sku,
          product: item.productName,
          category: item.categoryName || "-",
          subcategory: item.subcategoryName || "-",
          brand: getBrandName(item.brandId),
          price: item.price?.toLocaleString() || "0.00",
          unit: item.unit || "-",
          stock: stock.toLocaleString() || "0",
          quantityAlert: quantityAlert.toString() || "N/A",
          isLowStock: isLowStock, // Add this flag
          manufacturedDate: "2025-08-11",
          description: item.description || "-",
          productImage: "assets/img/product/default-product.jpg",
          img: "assets/img/profiles/avatar-05.jpg",
          restock: item.restock ?? false,
        };
      });

      setDataSource(mappedData);
      // setError(null);
    } catch (err) {
      console.error("Failed to fetch products:", err);
      // setError("Failed to load product list. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  // delete product
  const deleteProduct = async () => {
    if (!productToDelete) return;

    try {
      await axios.post(
        `${apiBase}api/v1/Product/DeleteProduct`,
        null,
        {
          params: {
            productId: productToDelete,
            storeId: storeId,
          },
        }
      );

      // Refresh the product list
      getProducts();

      setMessageModal({
        isOpen: true,
        title: "Success",
        message: "Product deleted successfully!",
        type: "success",
      });
    } catch (error) {
      console.error("Failed to delete product:", error);
      setMessageModal({
        isOpen: true,
        title: "Error",
        message: "Failed to delete product. Please try again.",
        type: "error",
      });
    } finally {
      setShowDeleteModal(false);
      setProductToDelete(null);
    }
  };
  // handle delete button click
  const handleDeleteClick = (productId) => {
    setProductToDelete(productId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    deleteProduct();
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setProductToDelete(null);
  };

  const closeMessageModal = () => {
    setMessageModal({ ...messageModal, isOpen: false });
  };
  // fetch subcategory
  //   const fetchSubcategories = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${apiBase}api/v1/Product/GetSubcategories`,
  //       { params: { storeId: storeId } }
  //     );
  //     setSubcategories(response.data.data || []);
  //   } catch (error) {
  //     console.error("Failed to load subcategories:", error);
  //   }
  // };
  // fetch reference data 
  const fetchReferenceData = async () => {
    try {
      const response = await axios.get(
        `${apiBase}api/v1/Product/GetReferenceData`,
        { params: { storeId: storeId } }
      );
      setCategories(response.data.data.categories || []);
      setBrands(response.data.data.brands || []);
    } catch (error) {
      console.error("Failed to load reference data:", error);
    }
  };
  useEffect(() => {
    fetchReferenceData();

    getProducts()
  }, []);

  useEffect(() => {
    // Only run getProducts once categories and brands are loaded
    if (categories.length > 0 && brands.length > 0) {
      getProducts();
    }
  }, [categories, brands]);

  // helper function to get categoryname from category id
  // const getCategoryName = (id) => {
  //   const category = categories.find((cat) => cat.categoryId === id);
  //   return category ? category.categoryName : "Unknown";
  // };
  // helper function to get brandName from brand id
  const getBrandName = (id) => {
    const brand = brands.find((b) => b.brandId === id);
    return brand ? brand.brandName : "Unknown";
  };
  //  filter products based on the restock flag
  const filteredDataSource = dataSource.filter(item => {
    // Restock filter
    const restockFilter = showOnlyRestock ? item.restock === true : item.restock === false;

    // Subcategory filter
    // const subcategoryFilter = selectedSubcategory ? item.subcategory === selectedSubcategory : true;

    return restockFilter
  });

  const columns = [

    {
      title: "Product",
      dataIndex: "product",
      flex: 2,
      width: '25%',
      render: (text) => (
        <div className="d-flex align-items-center">
          {/* <Link to="#" className="avatar avatar-md me-2">
            <ImageWithBasePath alt="" src={record.productImage} />
          </Link> */}
          <Link to="#">{text}</Link>
        </div>
      ),
      sorter: (a, b) => a.product.localeCompare(b.product),
    },
    //  {
    //   title: "SKU",
    //   dataIndex: "sku",
    //   // sorter: (a, b) => a.sku.length - b.sku.length,
    // },
    {
      title: "Category",
      dataIndex: "subcategory",
      flex: 1.5,
      width: '20%',
      sorter: (a, b) => a.subcategory.localeCompare(b.subcategory),
    },
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   flex: 1.5,
    //   width: '20%',
    //   sorter: (a, b) => a.category.localeCompare(b.category),
    // },
    // {
    //   title: "Subcategory", // New column
    //   dataIndex: "subcategory",
    //   sorter: (a, b) => a.subcategory.localeCompare(b.subcategory),
    // },

    // {
    //   title: "Brand",
    //   dataIndex: "brand",
    //   sorter: (a, b) => a.brand.localeCompare(b.brand),
    // },
    {
      title: "Price",
      dataIndex: "price",
      flex: 1,
      width: '20%',
      sorter: (a, b) => Number(a.price) - Number(b.price),
    },
    // {
    //   title: "Unit",
    //   dataIndex: "unit",
    //   flex: 1,
    //   width: '20%',
    //   sorter: (a, b) => a.unit.length - b.unit.length,
    // },
    // Conditionally include stock columns
    ...(showRestockColumns ? [
      {
        title: "Stock",
        dataIndex: "stock",
        sorter: (a, b) => Number(a.stock) - Number(b.stock),
      },
      {
        title: "Stock Alert",
        dataIndex: "quantityAlert",
        sorter: (a, b) => Number(a.quantityAlert) - Number(b.quantityAlert),
      }
    ] : []),
    // {
    //   title: "Manufactured Date", // New column
    //   dataIndex: "manufacturedDate",
    //   sorter: (a, b) => a.manufacturedDate.localeCompare(b.manufacturedDate),
    // },
    // {
    //   title: "Description", // New column
    //   dataIndex: "description",
    //   render: (text) => (
    //     <div className="description-cell">
    //       {text.length > 20 ? `${text.substring(0, 20)}...` : text}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Store Name", // New column
    //   dataIndex: "storeName",
    //   sorter: (a, b) => a.storeName.localeCompare(b.storeName),
    // },

    // {
    //   title: "Created By",
    //   dataIndex: "createdby",
    //   render: (text) => (
    //     <span className="userimgname">
    //       <Link to="/profile" className="product-img">
    //         <ImageWithBasePath alt="" src={record.img} />
    //       </Link>
    //       <Link to="/profile">{text}</Link>
    //     </span>
    //   ),
    //   sorter: (a, b) => a.createdby.length - b.createdby.length,
    // },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      flex: 1,
      width: '25%',
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to={route.editproduct}
              state={{ productId: record.key }}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => handleDeleteClick(record.key)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    }
  ];
  // const tableStyles = {
  //   '--table-flex-grow': '1 !important',
  //   '--table-flex-shrink': '1 !important',
  //   '--table-flex-basis': '0 !important',
  // };

  // const renderTooltip = (props) => (
  //   <Tooltip id="pdf-tooltip" {...props}>
  //     Pdf
  //   </Tooltip>
  // );
  // const renderExcelTooltip = (props) => (
  //   <Tooltip id="excel-tooltip" {...props}>
  //     Excel
  //   </Tooltip>
  // );

  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );
  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Product List</h4>
                {/* <h6>Manage your products</h6> */}
              </div>
            </div>

            <div className="d-flex align-items-center gap-3 ms-auto">
              {/* Restock Checkbox */}
              <div className="form-check mb-0">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="restockToggle"
                  checked={showOnlyRestock}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setShowOnlyRestock(checked);
                    setShowRestockColumns(checked);
                  }}
                />
                <label className="form-check-label fw-medium" htmlFor="restockToggle">
                  Restock Products
                </label>
              </div>
              {/* Subcategory Dropdown */}
              {/* <div className="form-group mb-0">
      <select
        className="form-select form-select-sm"
        value={selectedSubcategory}
        onChange={(e) => setSelectedSubcategory(e.target.value)}
      >
        <option value="">Select subcategory</option>
        {subcategories.map((subcat) => (
          <option key={subcat.subCategoryId} value={subcat.subCategoryName}>
            {subcat.subCategoryName}
          </option>
        ))}
      </select>
    </div> */}
            </div>
            <ul className="table-top-head">
              {/* <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>

              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li> */}
              {/* <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li> */}
            </ul>
            <div className="page-btn">
              <Link to={route.addproduct} className="btn btn-primary">
                <i className='ti ti-circle-plus me-1'></i>
                Add New Product
              </Link>
            </div>
            {/* <div className="page-btn import">
              <Link
                to="#"
                className="btn btn-secondary color"
                data-bs-toggle="modal"
                data-bs-target="#view-notes"
              >
                <Download className="feather me-2" />
                Import Product
              </Link>
            </div> */}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="">
              {/* <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search..."

                  />
                  <button className="btn btn-searchset">
                    <i className="ti ti-search"></i>
                  </button>
                </div>
              </div> */}
              {/* <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Product
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Lenovo IdeaPad 3
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Beats Pro{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Nike Jordan
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Apple Series 5 Watch
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Created By
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        James Kirwin
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Francis Chang
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Antonio Engle
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Leo Kelly
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Category
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Computers
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Electronics
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Shoe
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Electronics
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Brand
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Lenovo
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Beats
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Nike
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Apple
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
              {/* <div className="card-body"> */}

              {/* <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort">
                <Sliders className="info-img" />
                <Select
                  className="img-select"
                  classNamePrefix="react-select"
                  options={options}
                  placeholder="14 09 23"
                />
              </div>
            </div> */}
              {/* /Filter */}
              {/* <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="row">
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <Box className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={productlist}
                            placeholder="Choose Product"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <StopCircle className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={categorylist}
                            placeholder="Choose Category"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <GitMerge className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={subcategorylist}
                            placeholder="Choose Sub Category"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <StopCircle className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={brandlist}
                            placeholder="Nike"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <i className="fas fa-money-bill info-img" />

                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={price}
                            placeholder="Price"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <Link className="btn btn-filters ms-auto">
                            {" "}
                            <i
                              data-feather="search"
                              className="feather-search"
                            />{" "}
                            Search{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
              {/* /Filter */}

              <div className="table-responsive" style={{ marginTop: '60px' }}>
                <Table
                  columns={columns}
                  dataSource={filteredDataSource}
                  loading={loading}
                  pagination={{ PageSize: 10 }}
                  scroll={{ x: 'max-content' }}
                  rowClassName={(record) => record.isLowStock ? "low-stock-row" : ""}
                // style={{
                //   width: '100%',
                //   marginTop: '20px', 
                //   display: 'flex',
                //   flexDirection: 'column',
                //   flex: 'var(--table-flex-grow) var(--table-flex-shrink) var(--table-flex-basis)'
                // }}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
          <Brand
            storeId={storeId}
            onUploadSuccess={getProducts} />
        </div>
      </div>
      <>

        {/* Delete Confirmation Modal */}
        {showDeleteModal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="page-wrapper-new p-0">
                  <div className="content p-5 px-3 text-center">
                    <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                      <i className="ti ti-trash fs-24 text-danger" />
                    </span>
                    <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                      Delete Product
                    </h4>
                    <p className="text-gray-6 mb-0 fs-16">
                      Are you sure you want to delete this product?
                    </p>
                    <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                        onClick={handleCloseDeleteModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary fs-13 fw-medium p-2 px-3"
                        onClick={handleConfirmDelete}
                      >
                        Yes Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Message Modal */}
        <MessageModal
          isOpen={messageModal.isOpen}
          onClose={closeMessageModal}
          title={messageModal.title}
          message={messageModal.message}
          type={messageModal.type}
        />
        {/* styles for quantity alert */}
        <style>
          {`
  .low-stock-row {
    background-color: #ffcccc !important;
  }
  
  /* Remove hover effects to maintain the red background */
  .ant-table-wrapper .ant-table-tbody > tr:hover > td {
    background: transparent !important;
  }
  
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > td {
    background: transparent !important;
  }
  
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: transparent !important;
  }
    
`}
        </style>
      </>

    </>

  );
};

export default ProductList;
